import { Dialog } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialog-paper": {
    borderRadius: "var(--dialog-border-radius)",
  },
}));

/**
 * CustomDialog Component
 * @param {Object} props - Component props
 * @param {boolean} props.open - Whether the dialog is open
 * @param {function} props.onClose - Function to call when dialog is closed
 * @param {React.ReactNode} props.children - Content to display in the dialog
 * @param {string} props.maxWidth - Maximum width of the dialog ('xs' | 'sm' | 'md' | 'lg' | 'xl' | false)
 * @param {boolean} props.fullWidth - Whether the dialog should take full width
 * @param {string} props.className - Additional CSS classes
 */
const CustomDialog = ({ open, onClose, children, maxWidth = "sm", fullWidth = true, className = "" }) => {
  return (
    <StyledDialog open={open} onClose={onClose} maxWidth={maxWidth} fullWidth={fullWidth} className={className}>
      {children}
    </StyledDialog>
  );
};

export default CustomDialog;
